/* eslint-disable */
// import lib(s)
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import _ from 'lodash';

// import styles 
import styles from './CustomSingleSelect.css';
import CommonStyles from '../../CommonStyles.css';

// custom wrapper styles
const useStyles = makeStyles(theme => ({
  // base style of the select Component
  selectField: {
    'label + &': {
      marginTop: theme.spacing(0.25),
    },
  },
  menu: {
    height: 300
  }
}));


/** MaterialUI component - Select
 * Using wrapper style and custom props / function
 * Use for Text / Number / Tel / wrapper mask 
 * Props /use 
    label - label annotation 
    mandatory - required property,
    variant -  materialUI defined variant,
    selectedValue - selected value
    placeholder,
    onChange - input on change fn,
    menuItems - options
    valueKey - key to use for value,
    labelKeys - arrays of key to use for display item label,
    labelDisplayPrefix - used for display text prefix
    labelDisplaySeparator - used for label text separator
    stateKey - key name reference to update the sate in component
    validateForm - function callback to check / update component form state
 * */
const CustomSingleSelect = props => {
  const classes = useStyles();
  const [mandatoryError, setMandatoryError] = useState(false);
  const MANDATORY_TEXT = 'Required';
  const {
    label = '',
    placeholder = '',
    variant,
    mandatory = false,
    selectedValue = {},
    handleChange,
    menuItems = [],
    valueKey,
    labelKeys,
    labelDisplayPrefix,
    labelDisplaySeparator,
    stateKey,
    validateForm,
  } = props;

  // callback set component's form state
  const componentValidate = (state) => {
    if (validateForm !== undefined) {
      validateForm(state)
    }
  }

  // return display text with passed keys
  const getDisplayText = (option, keys) => {
    // check if only 1 key
    let displayText = '';
    if (keys.length === 1) {
      // this condition will not have labelDisplaySeparator
      return displayText = labelDisplayPrefix !== undefined ? `${labelDisplayPrefix} ${option[keys[0]]}` : `${option[keys[0]]}`;
    } else {
      let displayText = labelDisplayPrefix !== undefined ? `${labelDisplayPrefix} ` : '';
      keys.forEach((element, index) => {
        // passed labelDisplayPrefix, need to have prefix but ignore Separator
        if (labelDisplayPrefix && index === 0) {
          displayText = `${displayText} ${option[element]}`
        } else {
          // this condition will be when Separator is there, should be only with more then 1keys
          if (labelDisplaySeparator !== undefined) {
            displayText = `${displayText}${index === 0 ? '' : labelDisplaySeparator} ${option[element]}`
          } else {
            displayText = `${displayText} ${option[element]}`;
          }
        }
      });
      return displayText;
    }
  }

  // check if value changed, do the validation
  // covers manual(Programmatically) state change, which are not input changes 
  useEffect(() => {
    // show if field is empty
    if (mandatory && _.isEmpty(selectedValue)) {
      // setMandatoryError(true);
      componentValidate(true)
    } else if (mandatory && !_.isEmpty(selectedValue)) {
      setMandatoryError(false);
      componentValidate(false)
    }
  }, [selectedValue])

  const Placeholder = () => {
    return <label className={styles.placeholder}>
      {placeholder}
    </label>
  }

  return <React.Fragment>
    <InputLabel shrink >
      {label}
      {mandatory &&
        <label className={CommonStyles.asterisk}>&#x2a;
        </label>
      }
    </InputLabel>
    <FormControl fullWidth margin='dense' error={mandatoryError}>
      <Select
        name={label}
        className={classes.selectField}
        MenuProps={{ className: classes.menu }}
        value={_.isEmpty(selectedValue) ? '' : selectedValue[valueKey]}
        // label={placeholder}
        variant={variant}
        displayEmpty={true}
        renderValue={value => value == '' ? <Placeholder /> : selectedValue[labelKeys]}
        onChange={(e) => handleChange(e, stateKey)}
        onBlur={() => {
          if(mandatory && _.isEmpty(selectedValue)){
            setMandatoryError(true);
          }
        }
      }
      >
        {menuItems.length > 0 &&
          menuItems.map(item => {
            return <MenuItem
              key={item[valueKey]}
              value={item[valueKey]}
            >
              {getDisplayText(item, labelKeys)}
            </MenuItem>
          })
        }
      </Select>
      <FormHelperText>{mandatoryError && MANDATORY_TEXT}</FormHelperText>
    </FormControl>
  </React.Fragment >
}

export default CustomSingleSelect;


// WEBPACK FOOTER //
// ./src/views/components/Common/FormMUIWrapperComponents/CustomSingleSelect/CustomSingleSelect.jsx